import React from 'react';
import ServiceCard from '../components/ServiceCard';
import { SERVICES, ISO_STANDARDS } from '../data/constants';

export default function ServicesPage({ setPage }) {
  const goContact = () => { setPage('Contact'); window.scrollTo(0, 0); };

  return (
    <main className="page" id="main-content">

      {/* ── PAGE HERO ── */}
      <header className="page-hero">
        <div className="ph-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <ol itemScope itemType="https://schema.org/BreadcrumbList" style={{ listStyle: 'none', display: 'flex', gap: '0.4rem', padding: 0, margin: 0 }}>
              <li itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                <span itemProp="item" onClick={() => { setPage('Home'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
                  <span itemProp="name">Home</span>
                </span>
                <meta itemProp="position" content="1" />
              </li>
              <li aria-hidden="true" className="sep">/</li>
              <li itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                <span itemProp="name" className="cur">Services</span>
                <meta itemProp="position" content="2" />
              </li>
            </ol>
          </nav>
          <h1>ISO Certification, ZED Assessment &amp; Audit Services in India</h1>
          <p>
            Comprehensive, NABCB-accredited audit and inspection solutions — ISO certification, ZED Assessment, Food Safety Audit, Third Party Audit and more across India.
          </p>
        </div>
      </header>

      {/* ── ALL SERVICES ── */}
      <section className="section" aria-labelledby="all-services-heading">
        <div className="sec-inner">
          <div className="sec-tag">Our Services</div>
          <h2 className="sec-title" id="all-services-heading">
            Accredited Inspection, Certification &amp; Audit Services
          </h2>
          <p className="sec-lead">
            As a NABCB-accredited body, AQMCS offers a full range of independent inspection and certification services tailored to your industry and compliance needs.
          </p>
          <div className="services-grid" itemScope itemType="https://schema.org/ItemList">
            {SERVICES.map((s, i) => (
              <div key={i} itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                <meta itemProp="position" content={String(i + 1)} />
                <ServiceCard {...s} onLearnMore={goContact} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ISO STANDARDS ── */}
      <section className="section bg-light" aria-labelledby="iso-heading">
        <div className="sec-inner">
          <div className="sec-tag">Standards Coverage</div>
          <h2 className="sec-title" id="iso-heading">ISO Standards We Cover</h2>
          <p className="sec-lead">
            AQMCS provides certification and audit support across all major ISO management system standards — from ISO 9001 Quality Management to ISO 22000 Food Safety and ISO 45001 Occupational Health &amp; Safety.
          </p>
          <div className="iso-grid" role="list">
            {ISO_STANDARDS.map((item, i) => (
              <div key={i} className="iso-item" role="listitem">
                <span style={{ fontSize: '1.4rem' }} aria-hidden="true">{item.e}</span>
                <div>
                  <div className="iso-std">{item.std}</div>
                  <div className="iso-name">{item.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <div className="cta-banner">
        <div className="cta-inner">
          <h2>Not Sure Which Service You Need?</h2>
          <p>
            Our accredited experts will assess your requirements and recommend the right inspection and certification path for your organisation — at no obligation.
          </p>
          <button className="btn-blue" onClick={goContact} aria-label="Get a free assessment from AQMCS">
            Contact Now →
          </button>
        </div>
      </div>
    </main>
  );
}
